import { render, staticRenderFns } from "./DetailTukarGift.vue?vue&type=template&id=28bbb0de&scoped=true"
import script from "./DetailTukarGift.vue?vue&type=script&lang=js"
export * from "./DetailTukarGift.vue?vue&type=script&lang=js"
import style0 from "./DetailTukarGift.vue?vue&type=style&index=0&id=28bbb0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbb0de",
  null
  
)

export default component.exports